<template>
	<div id="app">
		<router-view></router-view>
		<div v-show="loading" class="loading">
			<div id="loader">
				<img src="~@/assets/img/loader/verde.svg">
			</div>
			<div id="loader2">
				<img src="~@/assets/img/loader/azul.svg">
			</div>
			<div id="loaderProgress">
				<div></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'app',
	computed: {
		loading () {
			return this.$store.state.loading
		}
	}
}

</script>

<style>
a{
	color: #0058B5;
}

input[type="submit"].form-control:focus{
	color: #FFF;
	background-color: #0058B5;
	border-color: none;
	outline: 0;
	box-shadow: 0;
}

</style>


<style lang="scss">
	/* Variaveis do boostrap*/
	$blue: #0058B5;
	/*$blue: #F00;*/
	$modal-lg: 1024px;

	$grid-breakpoints: (
		xs: 0,
		sm: 1px,
		md: 1px,
		lg: 1px,
		xl: 1px
	);

	$theme-colors: (
		"light-success": #c3e6cb,
		"light-warning": #ffeeba,
		"light-danger": #f5c6cb
	);

	/*
	O Alex pediu para diminuir o line-height geral, mas isso QUEBRA todo o layout
	$line-height-base: 1.2;
	*/

	/*
		Variaveis do element-ui
		node_modules\element-ui\packages\theme-chalk\src\common\var.scss
	*/
	$--font-path: '~element-ui/lib/theme-chalk/fonts';
	/*$--border-color-extra-light: #f2f6fc;*/
	$--border-color-extra-light: #c6dcfc;
	$--color-primary: #0058B5;

	@import "~bootstrap/scss/bootstrap.scss";
	@import "~bootstrap-vue/dist/bootstrap-vue.css";

	/*@import '~element-ui/lib/theme-chalk/index.css';*/
	@import "~element-ui/packages/theme-chalk/src/index";

	@import './assets/css/evento.css';
	@import './assets/css/estilo.css';
	@import './assets/css/estilo.scss';


</style>